import React from "react";
import { cn } from "../utils/classnames";

interface HamburgerMenuProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isOpen: boolean;
  menuSpanClassName?: string;
}

const menuSpanStyle = `absolute left-0 w-4 h-0.5 bg-new-beginnings-base
              transition-all duration-300 ease-in-out`;

const HamburgerMenu = React.forwardRef<HTMLButtonElement, HamburgerMenuProps>(
  ({ className, menuSpanClassName, isOpen, ...props }, ref) => {
    return (
      <button
        className={cn(
          `inline-flex cursor-pointer items-center bg-transparent font-jakarta-sans font-semibold`,
          className,
        )}
        {...props}
        ref={ref}
      >
        {isOpen ? "Close" : "Menu"}
        <figure className="relative ml-2 h-3 w-4">
          <div className={`relative ${isOpen ? "hamburger-open" : ""}`}>
            {["top-[1px]", "top-[6px]", "top-[11px]"].map(
              (spanOffset, index) => (
                <span
                  className={cn(
                    menuSpanStyle,
                    menuSpanClassName,
                    spanOffset,
                    isOpen ? "hamburger-open-span" : "",
                  )}
                  key={index}
                />
              ),
            )}
          </div>
        </figure>
      </button>
    );
  },
);

HamburgerMenu.displayName = "HamburgerMenu";

export default HamburgerMenu;
